export const creditCardContentBox = {
    showLockAndUnlockNavigation: true,
    showPayUpNavigation: true,
    cardLegend: {
        invertOutstandingAmount: true,
    },
};
